export const ADD_RESERVATION = 'ADD_RESERVATION'
export const ADD_RESERVATIONS = 'ADD_RESERVATIONS'
export const LOAD_RESERVATION = 'LOAD_RESERVATION'
export const SET_RESERVATION = 'SET_RESERVATION'
export const REMOVE_RESERVATION = 'REMOVE_RESERVATION'

